import { render, staticRenderFns } from "./documentRequerid.vue?vue&type=template&id=201b0873&scoped=true&"
import script from "./documentRequerid.vue?vue&type=script&lang=js&"
export * from "./documentRequerid.vue?vue&type=script&lang=js&"
import style0 from "./documentRequerid.vue?vue&type=style&index=0&id=201b0873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b0873",
  null
  
)

export default component.exports